var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.flg
    ? _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "store-news-block" },
          [
            _vm._l(_vm.lists, function(item, key) {
              return _c("div", { key: key, staticClass: "p-news-outline" }, [
                _c(
                  "div",
                  { staticClass: "body" },
                  [
                    _c("div", { staticClass: "header" }, [
                      _c("h5", { staticClass: "date" }, [
                        _vm._v(_vm._s(_vm.dateFormat(item.date)))
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "category" }, [
                        _c("li", [_vm._v(_vm._s(item.shop.parentName))]),
                        _vm._v(" "),
                        _c("li", [_vm._v(_vm._s(item.shop.name))])
                      ])
                    ]),
                    _vm._v(" "),
                    item.url === ""
                      ? [
                          _c("div", { staticClass: "title" }, [
                            _c("a", {
                              attrs: { href: item.permalink },
                              domProps: {
                                innerHTML: _vm._s(_vm.h(item.overview))
                              }
                            })
                          ])
                        ]
                      : [
                          _c("div", { staticClass: "title" }, [
                            _c("a", {
                              attrs: { href: item.url, target: "_blank" },
                              domProps: {
                                innerHTML: _vm._s(_vm.h(item.overview))
                              }
                            })
                          ])
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image" },
                  [
                    item.url === ""
                      ? [
                          _c("a", { attrs: { href: item.permalink } }, [
                            item.image
                              ? _c("img", {
                                  attrs: { src: item.image, alt: "" }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: "/assets/img/news_noimage.png",
                                    alt: ""
                                  }
                                })
                          ])
                        ]
                      : [
                          _c(
                            "a",
                            { attrs: { href: item.url, target: "_blank" } },
                            [
                              item.image
                                ? _c("img", {
                                    attrs: { src: item.image, alt: "" }
                                  })
                                : _c("img", {
                                    attrs: {
                                      src: "/assets/img/news_noimage.png",
                                      alt: ""
                                    }
                                  })
                            ]
                          )
                        ]
                  ],
                  2
                )
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "p-button-holder" }, [
              _c("div", { staticClass: "button" }, [
                _c(
                  "a",
                  {
                    staticClass: "p-button-link",
                    attrs: { href: _vm.setUrl(this.basename) }
                  },
                  [_vm._v("もっと見る")]
                )
              ])
            ])
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "p-hdg-weng" }, [
      _vm._v("お知らせ"),
      _c("span", { staticClass: "en" }, [_vm._v("NEWS")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }